import React from "react";
import logo from "@/assets/soverenx-logo.png";

export const BrandMark = ({ height = 30, className = "", chip = true }) => {
  const img = <img src={logo} alt="Soverenx Systems" style={{ height }} className="w-auto object-contain" data-testid="app-logo" />;
  if (!chip) return img;
  return (
    <div className={`inline-flex items-center rounded-md bg-black px-2.5 py-1.5 ${className}`}>
      {img}
    </div>
  );
};

export default BrandMark;
